import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CatalogService, EntryPoint, EntryPointService } from '@mirage-projects/cw-commons';
import { CatalogObject, CommonsConfigEnvironment, CONFIG_ENVIRONMENT } from '@mirage-projects/cw-models';

/**
 * Service implementation to manage the catalogs endpoints
 */
@Injectable({
    providedIn: 'root',
})
export class AppCatalogService implements CatalogService {
    constructor(
        private http: HttpClient,
        private entryPointService: EntryPointService,
        @Inject(CONFIG_ENVIRONMENT) private configEnvironment: CommonsConfigEnvironment
    ) {}

    /**
     * Retrieves the information of the latest projects and sites opened
     * @param projectData Creation parameters
     */
    getLatestDashboardElements(): Observable<CatalogObject[]> {
        const url = this.entryPointService.getResource(EntryPoint.LATEST_DASHBOARD_ELEMENTS);
        return this.http.get<CatalogObject[]>(`${url}`);
    }

    /**
     * Retrieves a catalog object
     * @param catalogUrl catalog url to load
     */
    getCatalogObject(catalogUrl: string): Observable<CatalogObject[]> {
        const url = this.entryPointService.getBaseUrl();
        return this.http.get<CatalogObject[]>(`${url}${catalogUrl}`);
    }
}
